import axios from 'axios';
import store from '@/store';
import router from '@/router';
import utils from '@/assets/js/utils';
import AES from '@/assets/js/AES.js';
// import cookies from 'js-cookie';
import ls from 'local-storage';
var md5 = require('js-md5');
// import {Message} from 'element-ui';
import {fetchAccessToken} from '@/assets/js/commonApi';



const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '登录过期，请重新登录',
    403: '没有权限',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    413: '文件过大，请重新上传',
    422: '当创建一个对象时，发生一个验证错误。',
    453: '访问Token已失效，请刷新页面重试',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};


// create an axios instance
let service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '', // api base_url
    timeout: 10 * 60 * 1000, // request timeout
    method: "post"
});

// const appid = process.env.VUE_APP_APPID || 'admin';
const {VUE_APP_ENV} = process.env;

// request interceptor
service.interceptors.request.use(
    async (config) => {
        // const _debugApi = store.state.debug;
        // if (_debugApi) {
        //     config.auth = false;
        //     config.url = '/api' + config.url;
        // } else {
        //     config.auth = config.auth !== false ? true : false;
        // }
        // if (VUE_APP_ENV === 'development') console.log('接口地址:', config.url, '\n提交参数:', JSON.stringify(config.data || config.params));
        // if (config.auth) {
        //     let paramSource = {
        //         action: config.url,
        //         method: config.method,
        //         query: config.params || null,
        //         body: config.data || null,
        //         qtime: new Date().getTime(), //Date.parse(new Date()) / 1000
        //         ranstr: utils.uuid(8)
        //     };
        //     const _paramSource = JSON.stringify(paramSource) + '';
        //     const sign = md5(_paramSource).toLowerCase();

        //     paramSource = AES.encrypt(JSON.stringify(paramSource));
        //     if (VUE_APP_ENV === 'development') console.log('解密后的参数', JSON.parse(AES.decrypt(paramSource)));

        //     config.data = {
        //         data: paramSource,
        //         sign: sign,
        //         appid: appid,
        //         terminal: 'web',
        //         version: '1.0.0'
        //     };
        //     config.method = 'POST';
        //     config.url = '/api/ht';
        //     config.params = null;
        // }

        // config.headers.CUSUT = cookies.get('CUSUT') || '';
        // config.headers.CUUSERREF = ls.get('token');
        // config.headers.CUSYSTIME = new Date().getTime();
        let _config = config.original ? 
            {   
                ...config,
                ...config.original,
                transformRequest:config.transformRequest,
                transformResponse:config.transformResponse
            } : {...config};
        
        _config.original = {..._config}//JSON.parse(JSON.stringify({..._config}))

        _config.adminApi = _config.auth !== false ? true : false;
        // if (config.gateway) {
            //签名集合 第一项 HTTP-Method
            _config.method = _config.method || 'post';
            let _Signature = [_config.method.toLowerCase()];

            //获取Content-Type
            const _ContentType = _config.headers['Content-Type'] ? _config.headers['Content-Type'] : _config.data && _config.adminApi ? 'application/json;charset=UTF-8' : "" ;
            if(_ContentType) {
                _config.headers['Content-Type'] = _ContentType;
            }

            //获取参数并MD5
            if(_config.data && _config.adminApi) _config.data = AES.encrypt(JSON.stringify(_config.data)) ;
            const _ContentMd5 = _config.data && _config.adminApi ? md5(_config.data).toLowerCase() : "";
            if(_ContentMd5) {
                _Signature.push(_ContentMd5);
                _config.headers['Content-MD5'] = _ContentMd5; //业务请求参数md5
            }
            

            //Authorization
            const _idToken = ls.get('CUSUT') || store.state && store.state.CUSUT; 
            if(_idToken) {
                const _Authorization = "Bearer " + _idToken;
                _Signature.push(_Authorization);
                _config.headers['Authorization'] = _Authorization;
            }

            //设置自定义header 以及需要签名的header
            let accessToken = store.state.accessToken;
            if(!accessToken && _config.url != "/token/get"){

                const res = await fetchAccessToken();
                const {result} = res.data;
                accessToken = store.state.accessToken || result;
            }
            const customHeader = {
                "X-Ca-Access-Token" : accessToken || "",
                "X-Ca-App-Key" : "17FCF4E6ED39479CB004EA1723450D74",
                "X-Ca-Encryption-Type" : _ContentMd5 ? 1 : -1,
                "X-Ca-Request-Nonce" : utils.uuid(20),
                "X-Ca-Request-Time" : new Date().getTime()
            }
            const customHeaderKeys = Object.keys(customHeader);

            _config.headers['X-Ca-Signature-Headers'] = customHeaderKeys.toString();
            customHeaderKeys.forEach(key => {
                _config.headers[key] = customHeader[key];
                _Signature.push(key.toLowerCase()+':'+customHeader[key]); //签名组装
            })
            
            //PathAndParameters
            _config.url = (_config.url != "/token/get" && _config.adminApi ? "/admin"  : "") + _config.url;
            let _PathAndParameters = _config.url;
            _config.params = {..._config.params, uref: ls.get('token'), appname: "showstart-admin"}
            if( _config.params ){
                _PathAndParameters = utils.objArgs(_config.url , _config.params);
            }
            _Signature.push(decodeURIComponent(_PathAndParameters)); //签名组装

            //签名格式化并加密
            _Signature.map((item,index) => {
                if(index < _Signature.length - 1){
                    _Signature[index] += "\n"
                }
            })
            _Signature = _Signature.toString();
            _Signature = _Signature.replaceAll('\n,','\n')

            // console.log(_Signature)

            _config.headers['X-Ca-Signature'] = AES.HmacSHA256(_Signature); //签名加密

            _config.url =  "/api" + _config.url;
            
        // }
        if (VUE_APP_ENV === 'development') console.log('请求:',_config);   
        return _config;
    },
    error => {
        // Do something with request error
        Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    res => {
        

        const encryptionType = res.headers['x-ca-encryption-type'] || "";
        if(encryptionType == 1){
            res.data = JSON.parse(AES.decrypt(res.data));
        }

        const {status, result} = res.data;
        res.data.state = res.data.state || 1;

        if (VUE_APP_ENV === 'development') console.log('接口返回:', res.data);

        if( status === 453 ){
            store.commit('setAccessToken', result);
            return service.request(res.config) 
        }else{
            // Stream file
            if (res.request.responseType === 'blob' && res.data instanceof Blob) {
                return res;
            }
            
            // if(status != 200){
            //     Message.error(msg);
            // }
            

            // Not login
            const failState = ['token.empty', 'user.login.status.no', 'USER_NOT_LOGIN_DEFAULT'];
            const path = router.currentRoute.path;
            const fullPath = router.currentRoute.fullPath;
            if ( failState.includes(res.data.state) || status == 401) {
                store.commit('logOut');
                if(path !== '/login'){
                    router.push({
                        path: '/login',
                        query: {redirect: fullPath}
                    });
                }
            }
            
            
            if(res.status != 200 || status != 200){
                const errorText = codeMessage[res.data.status] || codeMessage[res.status] || res.data.msg; 
                res.data.msg = errorText;
                res.data.state = 0;
            }
            
            return res;
        }
    },
    error => {
        console.log(error)
        let keys = Object.keys(codeMessage) , msg = "";
        keys.forEach(key => {
            if (error.message.includes(key)) msg = codeMessage[key];
        });
        if(msg) return {data: {state: 0, msg: msg}};
        
        // 过滤请求超时并显示提示
        if (/timeout/.test(error.message)) return {data: {state: 0, msg: '请求超时请重新尝试~'}};
        return Promise.reject(error);
    }
);

export default service;
